import React, { useContext } from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { AppContext } from "core/context";
import Style from "core/lib/style";
import Footer from "components/footer";
import RegistrationHeader from "components/registration-header";

const AuthStyleWrapper = ({ children }: { children: JSX.Element }) => {
    const appContext = useContext(AppContext);
    const cssName = Style.auth;

    useEffectOnce(() => {
        if (appContext.bodyCssName.includes(cssName)) {
            return;
        }

        appContext.updateBodyCssName(cssName);
    });

    return (
        <>
            <RegistrationHeader />

            <div className="main-container">
                {children}
            </div>

            <Footer />
        </>
    )
}

export default AuthStyleWrapper;
